import { render, staticRenderFns } from "./Articles.CarouselItem.vue?vue&type=template&id=09f407f4&scoped=true"
import script from "./Articles.CarouselItem.vue?vue&type=script&lang=js"
export * from "./Articles.CarouselItem.vue?vue&type=script&lang=js"
import style0 from "./Articles.CarouselItem.vue?vue&type=style&index=0&id=09f407f4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f407f4",
  null
  
)

export default component.exports